interface SplitTitleAndContentResult {
  title: string;
  content: string;
}

export const splitTitleAndContent = (str: string): SplitTitleAndContentResult => {
  const index = str.indexOf("\n");

  let title = "";
  let content = "";

  if (index >= 0) {
    title = str.slice(0, index);
    content = str.slice(index + 1);
  }

  return { title, content };
};
